import React from "react";
import Seo from "./Seo";
import { cmsPageSeo } from "../../constants/seo.mjs";

// Adapter for pages whose meta comes from the CMS (`meta` in the page API
// response). All tag rendering lives in <Seo>.
export default function MetaGenerator({ page_title, meta_desc, fallbackDescription, type, jsonLd, noindex }) {
    return (
        <Seo
            {...cmsPageSeo({ pageTitle: page_title, meta: meta_desc, fallbackDescription })}
            type={type}
            jsonLd={jsonLd}
            noindex={noindex}
        />
    );
}
